<template><div><h1 id="rfm-dimensionen" tabindex="-1"><a class="header-anchor" href="#rfm-dimensionen"><span>RFM-Dimensionen</span></a></h1>
<p>RFM-Dimensionen — Parametrisierung der RFM-Dimensionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die fest programmierten RFM-Dimensionen parametrisiert.Die RFM-Dimensionen sind Basis für die <RouteLink to="/referenz/refs/ft.refdata.rfmadr.html" title="RFM-Anzeige">RFM-Anzeige</RouteLink> in der Adressmaske und die RFM-Auswertungen. Zu jeder Dimension gehört eine Tabelle mit Punktewerten (siehe <RouteLink to="/referenz/refs/ft.refdata.trfmdimpos.html" title="RFM-Dimensionen, Positionen">RFM-Dimensionen, Positionen</RouteLink>).</p>
<h3 id="dimesionen" tabindex="-1"><a class="header-anchor" href="#dimesionen"><span>Dimesionen</span></a></h3>
<h4 id="achse-finanzieller-nutzen" tabindex="-1"><a class="header-anchor" href="#achse-finanzieller-nutzen"><span>Achse: &quot;Finanzieller Nutzen&quot;</span></a></h4>
<table>
<thead>
<tr>
<th>Dimension</th>
<th>Beschreibung</th>
<th>Zeitperiode</th>
</tr>
</thead>
<tbody>
<tr>
<td>Spendenumsatz letzte Periode</td>
<td>Spendenumsatz in der letzten Zeitperiode</td>
<td>Auswerteperiode (Datum minus x Tage) (Soll=365). Im Spendenumsatz sind je nach kundenspezifischer Festlegung auch die Zusagenumsätze enthalten!</td>
</tr>
<tr>
<td>Durchschnittlicher Jahresumsatz Spenden</td>
<td>Spendenumsatz der Zeitperiode geteilt durch Anzahl Jahre, die diese Periode beinhaltet</td>
<td>Auswerteperiode (Datum minus x Tage)</td>
</tr>
<tr>
<td>Durchschnittlicher Betrag pro Spende</td>
<td>Spendenumsatz innerhalb der Zeitperiode, geteilt durch Anzahl Response-Ereignisse.</td>
<td>Auswerteperiode (Datum minus x Tage)</td>
</tr>
<tr>
<td>Verkaufsumsatz letzte Periode</td>
<td>Verkaufsumsatz in der letzten Zeitperiode</td>
<td>Auswerteperiode (Datum minus x Tage) (Soll=365)</td>
</tr>
<tr>
<td>Durchschnittlicher Jahresumsatz Verkauf</td>
<td>Verkaufsumsatz innerhalb der Zeitperiode geteilt durch Anzahl Jahre, die diese Periode beinhaltet</td>
<td>Auswerteperiode (Datum minus x Tage)</td>
</tr>
<tr>
<td>Durchschnttlicher Betrag pro Kauf</td>
<td>Verkaufsumsatz innerhalb der Zeitperiode, geteilt durch Anzahl Response-Ereignisse.</td>
<td>Auswerteperiode (Datum minus x Tage)</td>
</tr>
</tbody>
</table>
<h4 id="achse-aktivitat-engagement-bindung" tabindex="-1"><a class="header-anchor" href="#achse-aktivitat-engagement-bindung"><span>Achse: &quot;Aktivität, Engagement, Bindung&quot;</span></a></h4>
<table>
<thead>
<tr>
<th>Dimension</th>
<th>Beschreibung</th>
<th>Bereich</th>
</tr>
</thead>
<tbody>
<tr>
<td>Anzahl Monate seit letzter Spende</td>
<td>Monate, die das letzte Response-Ereignis mit Ereignissituation RSS zurück liegt</td>
<td>Auswerteperiode in Tagen</td>
</tr>
<tr>
<td>Anzahl Monate seit erster Spende</td>
<td>Monate, die das erste Response-Ereignisse mit Ereignissituation RSS zurück liegt.</td>
<td>Auswerteperiode in Tagen</td>
</tr>
<tr>
<td>Differenz Jahresumsatz Spende zur vorherigen Periode</td>
<td>Jahresumsatz Spende vom aktuellen Jahr (Tag-1 bis -365) minus Jahresumsatz vor definierten Zeitperiode (bei einem Jahr sind es Tage -366 bis -730)</td>
<td>Anzahl Tage für Verleichsjahr</td>
</tr>
<tr>
<td>Anzahl Monate seit letztem Kauf</td>
<td>Monate, die das letzte Response-Ereignis mit Ereignissituation RWV zurück liegt</td>
<td>nicht berücksichtigt</td>
</tr>
<tr>
<td>Anzahl Monate seite erstem Kauf</td>
<td>Monate, die das erste Response-Ereignisse mit Ereignissituation RWV zurück liegt.</td>
<td>Auswerteperiode in Tagen</td>
</tr>
<tr>
<td>Durchschnittliche Anzahl Käufe pro Jahr</td>
<td>Anzahl Response-Ereignisse mit Ereignissituation RWV innerhalb der Zeitperiode, geteilt durch die Dauer der Periode in Jahren</td>
<td>Auswerteperiode (Datum minus x Tage)</td>
</tr>
</tbody>
</table>
<p>Pfad: <code v-pre>Personen → Tabellen → RFM-Dimensionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Name</dt>
<dd>Bezeichnung der Dimension</dd>
<dt>Achse</dt>
<dd>Die Dimension gehört zur Achse &quot;Finanzieller Nutzen&quot; oder &quot;Aktivität, Engagement, Bindung&quot; (nicht editierbar).</dd>
<dt>Typ</dt>
<dd>Dimension beeinflusst den <a class="link" href="ft.refdata.trfmdimpos.html" title="RFM-Dimensionen, Positionen">Punktewert</a> für &quot;Spende&quot; oder &quot;Kauf&quot;</dd>
<dt>Einheit</dt>
<dd>Einheit, die für die Erfassung der <a class="link" href="ft.refdata.trfmdimpos.html" title="RFM-Dimensionen, Positionen">Punktewerte</a> gilt (z.B. &quot;CHF&quot; oder &quot;Monat&quot;&quot;).</dd>
<dt>Bereich</dt>
<dd>Dieser Wert ist von der jeweiligen Dimension abhängig. Er definiert z. Bsp. bei der Dimension &quot;Verkaufsumsatz laufendes Jahr&quot; die Zeitspanne für die Auswertung (heutiges Datum -365 Tage).</dd>
<dt>Gewichtung</dt>
<dd>Multiplikator für den Punktewert. Die Punkte der Dimension werden mit diesem Wert multipliziert.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.rfmadr.html" title="RFM-Anzeige">RFM-Dimensionen anzeigen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.trfmdimpos.html" title="RFM-Dimensionen, Positionen">RFM-Dimensionen, Positionen</RouteLink></p>
</div></template>


